import { useCurrentTenant } from "core/features/auth/tenant.store";
import useParametrosAssembleia from "core/features/assembleia/hooks/useParametrosAssembleia";
import useSaveParametrosAssembleia from "core/features/assembleia/hooks/useSaveParametrosAssembleia";
import { Checkbox } from "@chakra-ui/checkbox";
import { Modal, Select, Row, Col } from "antd";
import { Flex } from "@chakra-ui/layout";
import { Heading } from "@chakra-ui/react";
import Field from "ui/components/Input/Field";
import Button from "ui/components/Button";
import PrimaryButton from "ui/components/Button/PrimaryButton";
import { ParametrosForm } from "ui/pages/Admin/Administracao/AssembleiasPages/Listagem/typings";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import { showErrorAxios, showSuccess } from "infra/helpers/alerta";
import { useLoading } from "ui/components/GlobalLoading";
const { Option } = Select;

function ModalParametrosAssembleia({
  open,
  onClose,
}: {
  open: boolean;
  onClose: Function;
}) {
  const { tenant } = useCurrentTenant();

  const { isLoading: isLoadingSave, mutate: handleSave } =
    useSaveParametrosAssembleia(tenant?.id as string);

  const {
    data: parametros,
    isLoading: isLoadingParametros,
    isFetching: isFetchingParametros,
  } = useParametrosAssembleia(tenant?.id as string);

  const { control, handleSubmit, reset } = useForm<ParametrosForm>({
    reValidateMode: "onChange",
    mode: "onChange",
  });

  useEffect(() => {
    if (parametros)
      parametros.bloquearInadimplente = !parametros.bloquearInadimplente;

    reset(parametros);
  }, [parametros, reset]);

  const onSubmit = (form: ParametrosForm) => {
    handleSave(form, {
      onError: (err) => {
        showErrorAxios(err);
      },
      onSuccess: () => {
        showSuccess();
        // onSaved?.();
        onClose?.();
      },
    });
  };

  useLoading(isLoadingParametros || isFetchingParametros);

  return (
    <Modal
      width={"500px"}
      footer={
        <Flex justifyContent="flex-end" gridGap="16px">
          <Button type="button" onClick={() => onClose()}>
            CANCELAR
          </Button>
          <PrimaryButton
            onClick={handleSubmit(onSubmit)}
            disabled={isLoadingSave || isFetchingParametros}
            isLoading={isLoadingSave || isFetchingParametros}
          >
            SALVAR
          </PrimaryButton>
        </Flex>
      }
      visible={open}
      onCancel={() => onClose()}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Flex>
          <Heading mb={8} size="md">
            Check-in
          </Heading>
        </Flex>
        <Row gutter={16}>
          <Col sm={12}>
            <Field
              label="Antecedência para o check-in"
              control={control}
              name="tipoIntervaloCheckin"
              render={({ field, isInvalid }) => (
                <Select
                  style={{ width: "100%" }}
                  id="tipoIntervaloCheckin"
                  size="large"
                  value={field.value}
                  onChange={(option) => field.onChange(option)}
                >
                  <Option value="minuto">Minutos</Option>
                  <Option value="hora">Horas</Option>
                </Select>
              )}
            />
          </Col>
          <Col sm={12}>
            <Field
              label="Intervalo de Antecedência"
              control={control}
              name="intervaloCheckin"
              inputProps={{
                placeholder: "Intervalo de check-in",
                type: "number",
              }}
            />
          </Col>
        </Row>
        <Flex flexDirection="column" mt={10}>
          <Heading mb={8} size="md">
            Inadimplentes
          </Heading>
          <Field
            control={control}
            name="bloquearInadimplente"
            render={({ field }) => (
              <Checkbox
                style={{ fontSize: "14.4px" }}
                isChecked={field.value}
                onChange={() => {
                  field.onChange(!field.value);
                }}
              >
                Inadimplentes podem votar
              </Checkbox>
            )}
          />
        </Flex>
      </form>
    </Modal>
  );
}

export default ModalParametrosAssembleia;
